import './Toggle.css';
import React from 'react';
var Toggle = function Toggle(_ref) {
  var _onChange = _ref.onChange,
    value = _ref.value,
    label = _ref.label,
    rtl = _ref.rtl,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className || "", " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "toggle__field"
  }, /*#__PURE__*/React.createElement("label", {
    className: "toggle__label",
    title: label,
    "aria-label": label,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.currentTarget.click();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-small toggle__text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "toggle__switch"
  }, /*#__PURE__*/React.createElement("input", {
    className: "toggle__input",
    title: label,
    "aria-label": label,
    defaultChecked: value,
    type: "checkbox",
    value: value ? value.toString() : 'false',
    onChange: function onChange() {
      _onChange(!value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "toggle__shape"
  })))));
};
export default Toggle;
var commonStyles = "cg1yuz8";
var ltrStyles = "lncoxtc";
var rtlStyles = "rb0vpy7";